export const environment = {
  production: false,
  apiUrl: 'https://6y1i3jwu95.execute-api.sa-east-1.amazonaws.com/development',
  cognito: {
    userPoolId: 'sa-east-1_cP8Br07E7',
    userPoolClientId: '1ac8rrqkv0f4ejo7o4jfone31d',
  },
  stripe: {
    publicKey: 'pk_test_51TP2GhJlQ962KYIiyqulFQhBZvt097hkkiGBRPBolEtgOFmanNIM7LxbNU4AoD1vJjYAVtDsGf1Cvx0K6s8ZVWE3004pnw0CHy',
    monthlyPriceId: 'price_1TP7RxJlQ962KYIixQdkZ1Iu',
    annualPriceId: 'price_1TP7SaJlQ962KYIiY98cpQJL'
  },
  // Optional Google Maps API key: set this in local env for map view
  googleMapsApiKey: ''
};
